import {useMediaQuery} from '@mui/material'
import React, {useState} from 'react'
import styles from './styles.module.scss'

export type ImageSliderPreviewProps = {
  images: string[]
  style?: object,
  className?: string
}

export const ImageSliderPreview: React.FC<ImageSliderPreviewProps> = ({
  style,
  images,
  className
}) => {
  const [currentImage, setCurrentImage] = useState(0)
  const [isHover, setIsHover] = useState(false)
  const is768p = useMediaQuery(`(max-width: ${styles.is768p})`)

  return (
    <div
      className={`${styles.container} ${className || ''}`}
      style={{backgroundImage: `url(${images[currentImage]})`, ...style}}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className={`${styles.dashContainer} ${images.length > 1 && isHover && !is768p ? '' : styles.dashContainer__disable}`}>
        {images.map((_, index) => (<Dash key={index} setCurrentImage={setCurrentImage} index={index} />))}
      </div>
    </div>
  )
}

type DashProps = {
  setCurrentImage: Function,
  index: number
}

const Dash: React.FC<DashProps> = ({setCurrentImage, index}) => {
  const [isActive, setIsActive] = useState(false)

  const mouseHandler = (state: boolean) => {
    setIsActive(state)
    setCurrentImage(state ? index : 0)
  }

  return (
    <div
      className={styles.dashWrapper}
      onMouseEnter={() => mouseHandler(true)}
      onMouseLeave={() => mouseHandler(false)}
    >
      <div className={`${styles.dash} ${isActive ? styles.dash__active : ''}`} />
    </div>
  )
}